import { AlertTriangle } from 'lucide-react';

export function ErrorBanner({ message }: { message: string | null }) {
  if (!message) return null;
  return (
    <div className="qh-auth-public__error flex items-start gap-3 bg-red-50 border border-red-100 text-red-800 rounded-2xl p-4 text-sm font-medium mb-4">
      <AlertTriangle className="w-4 h-4 mt-0.5 shrink-0" />
      <span>{message}</span>
    </div>
  );
}
